import { Button } from "antd";
import ZhEmptyMedia from "@/views/components/zhEmptyMedia";
import type { TradeOrderData } from "../TradeOrderComponentPrimitives";

export interface ProveMaterialProps {
    items?: TradeOrderData[];
    onPreview?: (file: TradeOrderData) => void;
    onDownload?: (file: TradeOrderData) => void;
}

/** 提货凭证展示文件名、上传人和时间，操作回调由父页面决定预览或下载。 */
export default function ProveMaterial({ items = [], onPreview, onDownload }: ProveMaterialProps) {
    // Vue 旧版的四列顺序中，六处水尺的第 4 个位置是空白占位，不是第四个水尺卡片。
    const materials: Array<string | null> = [
        "吨位证明",
        "砂石来源证明",
        "到装货港图片/视频",
        "清仓图片/视频",
        "六处水尺-1",
        "六处水尺-2",
        "六处水尺-3",
        null,
        "六处水尺-4",
        "六处水尺-5",
        "六处水尺-6"
    ];
    return (
        <section className="section-card mb-4 trade-order-proof-material">
            <div className="flex items-center justify-between mb-4">
                <div className="section-title mb-0">凭证材料</div>
                <Button type="primary" onClick={() => onPreview?.(items[0] || {})}>
                    上传
                </Button>
            </div>
            <div
                className="grid gap-y-4"
                style={{ gridTemplateColumns: "repeat(4, 240px)", columnGap: 74 }}
            >
                {materials.map(label => (
                    label ? (
                        <div key={label} style={{ width: 240 }} onClick={() => onDownload?.({ fileName: label })}>
                            <div className="mb-2">{label}</div>
                            <ZhEmptyMedia height="135px" tip="暂无图片或视频" width="240px" />
                        </div>
                    ) : (
                        <div key="six-water-gauge-placeholder" style={{ width: 240 }} />
                    )
                ))}
            </div>
        </section>
    );
}
